/**
 * 각 노드의 끝점을 기준으로 이웃 노드 계산 시 호출
 * Used to determine the coordinate that will be used to filter items that are over the "edge"
 * @param isVertical
 * @param layout
 * @param isIncremental
 * @param isSibling
 */
var getCutoffCoordinateFromEdge = function (isVertical, layout, isIncremental, isSibling) {
    if (isSibling === void 0) { isSibling = false; }
    var itemX = (layout === null || layout === void 0 ? void 0 : layout.left) ? layout.left : 0;
    var itemY = (layout === null || layout === void 0 ? void 0 : layout.top) ? layout.top : 0;
    var itemWidth = (layout === null || layout === void 0 ? void 0 : layout.width) ? layout.width : 0;
    var itemHeight = (layout === null || layout === void 0 ? void 0 : layout.height) ? layout.height : 0;
    // coordinate, item size 를 구한다
    // vertical 이면 세로 시작 좌표 + 높이
    // 아니면 가로 시작 좌표 + 넓이
    var coordinate = isVertical ? itemY : itemX;
    var itemSize = isVertical ? itemHeight : itemWidth;
    // eslint-disable-next-line no-nested-ternary
    return isIncremental ? (isSibling ? coordinate : coordinate + itemSize) : isSibling ? coordinate + itemSize : coordinate;
};
export default getCutoffCoordinateFromEdge;
